var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"height":"250px"}},[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('h1',[_vm._v("Logged Out")])]),_c('v-card-text',{staticClass:"d-flex justify-center my-6"},[_c('v-btn',{attrs:{"color":"primary","to":"/"}},[_vm._v(" Return to login ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }